/* eslint-disable no-case-declarations */
import { validateTemplate } from '@shared/validation/validateTemplate';
import { setupCMPCustomAfterUtiq } from '@utiqLoader/CMP/custom';
import { setupCMPAgnosticAfterUtiq } from '@utiqLoader/CMP/agnostic';
import {
  setupCMPDidomiBeforeUtiq,
  setupCMPDidomiAfterUtiq,
} from '@utiqLoader/CMP/didomi';
import {
  setupCMPOptanonBeforeUtiq,
  setupCMPOptanonAfterUtiq,
} from '@utiqLoader/CMP/optanon';
import {
  AgnosticData,
  CustomData,
  DidomiData,
  OptanonData,
} from '@utiqLoader/consentManagementProvidersHandlers/constants';

export async function setupCMPBeforeUtiq(): Promise<void> {
  const Utiq = window.Utiq;
  if (!Utiq) throw new Error('window.Utiq === undefined');

  switch (Utiq.config?.CMP) {
    case DidomiData.name:
      return setupCMPDidomiBeforeUtiq();

    case OptanonData.name:
      return setupCMPOptanonBeforeUtiq();

    default:
      return Promise.resolve();
  }
}

export async function setupCMPAfterUtiq(): Promise<void> {
  const Utiq = window.Utiq;
  if (!Utiq) throw new Error('window.Utiq === undefined');

  const config = Utiq.config;
  if (!config) return;

  switch (config.CMP) {
    case DidomiData.name:
      const { isValid: isDidomiConfigValid } = validateTemplate({
        fieldsTemplate: DidomiData.fieldsTemplate,
        validationTargetObject: config,
        logIdentificator: DidomiData.name,
      });
      if (isDidomiConfigValid) {
        await setupCMPDidomiAfterUtiq();
      }
      break;

    case OptanonData.name:
      const { isValid: isOptanonConfigValid } = validateTemplate({
        fieldsTemplate: OptanonData.fieldsTemplate,
        validationTargetObject: config,
        logIdentificator: OptanonData.name,
      });
      if (isOptanonConfigValid) {
        await setupCMPOptanonAfterUtiq();
      }
      break;

    case AgnosticData.name:
      const { isValid: isAgnosticConfigValid } = validateTemplate({
        fieldsTemplate: AgnosticData.fieldsTemplate,
        validationTargetObject: config,
        logIdentificator: AgnosticData.name,
      });
      if (isAgnosticConfigValid) {
        setupCMPAgnosticAfterUtiq();
      }
      break;

    default:
      const { isValid: isCustomConfigValid } = validateTemplate({
        fieldsTemplate: CustomData.fieldsTemplate,
        validationTargetObject: config,
        logIdentificator: CustomData.name,
      });
      if (isCustomConfigValid) {
        setupCMPCustomAfterUtiq();
      }
      break;
  }
}
